import {
  VENDORS_ALL,
  VENDORS_ALL_SUCCESS,
  VENDORS_CREATE,
  VENDORS_CREATE_SUCCESS,
  VENDORS_DELETE,
  VENDORS_DELETE_SUCCESS,
  VENDORS_GET,
  VENDORS_GET_SUCCESS,
  VENDORS_UPDATE,
  VENDORS_UPDATE_PAGINATION,
  VENDORS_UPDATE_SUCCESS
} from "redux/constants/Vendors"

export const getVendors = (page = 1, perPage = 10, search = "") => {
  return {
    type: VENDORS_ALL,
    search,
    perPage,
    page,
  }
}

export const getVendorsSuccess = (vendors, total, from, to) => {
  return {
    type: VENDORS_ALL_SUCCESS,
    vendors,
    total,
    from,
    to,
  }
}

export const getVendor = (id) => {
  return {
    type: VENDORS_GET,
    id,
  }
}

export const getVendorSuccess = (vendor) => {
  return {
    type: VENDORS_GET_SUCCESS,
    vendor,
  }
}

export const createVendor = (data, history) => {
  return {
    type: VENDORS_CREATE,
    data,
    history,
  }
}

export const createVendorSuccess = (vendor) => {
  return {
    type: VENDORS_CREATE_SUCCESS,
    vendor,
  }
}

export const updateVendor = (id, data, history) => {
  return {
    type: VENDORS_UPDATE,
    id,
    data,
    history,
  }
}

export const updateVendorSuccess = (id, vendor) => {
  return {
    type: VENDORS_UPDATE_SUCCESS,
    id,
    vendor,
  }
}

export const updateVendorsPagination = (perPage, page) => ({
  type: VENDORS_UPDATE_PAGINATION,
  perPage,
  page,
})


export const deleteVendor = (id, history) => {
  return {
    type: VENDORS_DELETE,
    id,
    history,
  }
}

export const deleteVendorSuccess = (id) => {
  return {
    type: VENDORS_DELETE_SUCCESS,
    id,
  }
}